import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import FileSaver from "file-saver";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { FaFileCsv, FaFilePdf, FaFileExcel } from "react-icons/fa6";
import FileExport from "../../../Assets/Images/CommanImages/fileexport.png";
import Filter from "../../../Assets/Images/CommanImages/filter.png";
import columnaddition from "../../../Assets/Images/CommanImages/rectangleplus.png";
import searchicon from "../../../Assets/Images/CommanImages/searchyellow.png";
import updown from "../../../Assets/Images/CommanImages/updown.png";
import print from "../../../Assets/Images/CommanImages/print.png";
import cross from "../../../Assets/Images/CommanImages/cross_cancel.png";
import upimg from "../../../Assets/Images/CommanImages/up_arrow.png";
import downimg from "../../../Assets/Images/CommanImages/down_arrow.png";
import leftArrow from "../../../Assets/Images/CommanImages/Larrowbar.png";
import rightArrow from "../../../Assets/Images/CommanImages/Rarrowbar.png";
import reportImg from "../../../Assets/Images/client_logos/Reports/report_logo.png"
import watermarkImg from "../../../Assets/Images/client_logos/Reports/water_mark_img.png"
import "../../StudentRegistration/StudentRegistrationDashboard/studentdashboard.css";
import femaleImg from "../../../Assets/Images/Landing/female_01.png";
import maleImge from "../../../Assets/Images/Landing/male_01.png";

const TemRegDetailsTable = ({
  headers,
  data,
  searchPlaceholder,
  children,
  isColumnDivVisible,
  setIsColumnDivVisible,
  dataClient,
  isExpanded,
  ReportPageHeader,
  course, batch, date, test,
  showAllColumns,             // NEW — if true, all headers shown by default
}) => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || "Unknown User";
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [visibleColumns, setVisibleColumns] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [isSearchModalVisible, setIsSearchModalVisible] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [currentSearchIndex, setCurrentSearchIndex] = useState(0);
  const modalRef = useRef(null);
  const columnDivRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setIsModalVisible(false);
      }
      if (
        columnDivRef.current &&
        !columnDivRef.current.contains(event.target)
      ) {
        setIsColumnDivVisible(false); // Close the column div without resetting columns
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setIsModalVisible, setIsColumnDivVisible]);

  const [userSelectedColumns, setUserSelectedColumns] = useState(null);

useEffect(() => {
    if (headers.length > 0) {
      if (showAllColumns) {
        const allCols = headers.filter(h => h !== "Student ID" && h !== "Gender ID");
        if (userSelectedColumns) {
          // Preserve previously selected columns that exist in new headers
          const preserved = userSelectedColumns.filter(col => allCols.includes(col));
          setVisibleColumns(preserved.length > 0 ? preserved : allCols);
        } else {
          setVisibleColumns(allCols);
        }
      } else {
        const defaultColumns = ["Student Name", "Roll Number", "Batch Name", "Gender", "Date of Birth"]
        const allCols = headers.filter(h => h !== "Student ID" && h !== "Gender ID");
        if (userSelectedColumns) {
          // Preserve previously selected columns that exist in new headers
          const preserved = userSelectedColumns.filter(col => allCols.includes(col));
          setVisibleColumns(preserved.length > 0 ? preserved : allCols.filter(h => defaultColumns.includes(h)));
        } else {
          const columnsToShow = allCols.filter(h => defaultColumns.includes(h));
          setVisibleColumns(columnsToShow);
        }
      }
    } else {
      setVisibleColumns([]);
    }
  }, [headers, showAllColumns]);

  const sortedData = React.useMemo(() => {
    let sortableData = [...data];
    if (sortConfig.key !== null) {
      sortableData.sort((a, b) => {
        const colIndex = headers.indexOf(sortConfig.key);
        if (a[colIndex] < b[colIndex]) {
          return sortConfig.direction === "asc" ? -1 : 1;
        }
        if (a[colIndex] > b[colIndex]) {
          return sortConfig.direction === "asc" ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableData;
  }, [data, sortConfig, headers]);

  const requiredColumns = ["Student Name", "Total Marks", "Rank", "Botany", "Chemistry", "Physics", "Zoology", "Maths"];

  const handleColumnSelection = (column) => {
    let updated;
    if (visibleColumns.includes(column)) {
      updated = visibleColumns.filter((col) => col !== column);
    } else {
      if (column === "Photo") {
        updated = ["Photo", ...visibleColumns];
      } else {
        updated = [...visibleColumns, column];
      }
    }
    setVisibleColumns(updated);
    setUserSelectedColumns(updated); // ✅ remember user's choice
  };
  
  const handleSort = (column) => {
    let direction = "asc";
    if (sortConfig.key === column && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key: column, direction });
  };

  const handleExportClick = () => {
    if (data.length > 0) {
      setIsModalVisible(true);
    }
  };

  const handleColumnDivClick = () => {
    if (data.length > 0) {
      setIsColumnDivVisible(!isColumnDivVisible);
    }
  };

  // SHASHI CODE handleExport 
  const handleExport = (type) => {
    const exportData = sortedData.map((row) =>
      visibleColumns.map((column) => row[headers.indexOf(column)])
    );
      if (type === "excel" || type === "csv") {
        // Exclude "Photo" column for Excel and CSV exports
        const exportColumns = visibleColumns.filter((col) => col !== "Photo");
        const filteredExportData = sortedData.map((row) =>
          exportColumns.map((column) => row[headers.indexOf(column)])
        );

        const worksheet = XLSX.utils.aoa_to_sheet([
          exportColumns,
          ...filteredExportData,
        ]);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  
      const fileExtension = type === "csv" ? "csv" : "xlsx";
      const mimeType =
        type === "csv"
          ? "text/csv"
          : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  
      const file = XLSX.write(workbook, {
        bookType: fileExtension,
        type: "array",
      });
      const blob = new Blob([file], { type: mimeType });
  
      // Trigger "Save As" dialog with a default file name (browser settings dependent)
      FileSaver.saveAs(blob, `${ReportPageHeader}.${fileExtension}`);
    } else if (type === "pdf") {
      const doc = new jsPDF();
      doc.autoTable({
        head: [visibleColumns], // Use the visible columns for the PDF header
        body: exportData,
      });
      doc.save(`${ReportPageHeader}.pdf`);
    }
  };

  const getGenderAvatar = (originalRow) => {
  const genderIdIndex = headers.indexOf("Gender ID");
  const genderId = originalRow[genderIdIndex];
  return genderId === 1 ? maleImge : femaleImg; // 2 and 3 both female
};


  // Convert avatar images to base64 for print use
  const [maleBase64, setMaleBase64] = useState('');
  const [femaleBase64, setFemaleBase64] = useState('');

  useEffect(() => {
    const toBase64 = (src) => new Promise((resolve) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        canvas.getContext('2d').drawImage(img, 0, 0);
        resolve(canvas.toDataURL('image/png'));
      };
      img.onerror = () => resolve(''); 
      img.src = src;
    });

    toBase64(maleImge).then(setMaleBase64);
    toBase64(femaleImg).then(setFemaleBase64);
  }, []);

const [isPrinting, setIsPrinting] = useState(false);

  const handleSaveAndPrint = () => {
     if (isPrinting) return;
  
  setIsPrinting(true);
  
    const exportData = sortedData.map((row) =>
      visibleColumns.map((column) => row[headers.indexOf(column)])
    );
    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleDateString('en-GB', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });
    const formattedTime = currentDate.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
    const formattedDateTime = `${formattedDate}, ${formattedTime}`;

    const availablePageHeight = 630;
    const headerHeight = 150;
    const footerHeight = 50;

    const hasPhotoColumn = visibleColumns.includes("Photo");
    const rowHeight = hasPhotoColumn ? 50 : 20;

    const pageHeightForData = availablePageHeight - headerHeight - footerHeight;
    const rowsPerPage = Math.floor(pageHeightForData / rowHeight);

    const printTotalPages = Math.ceil(sortedData.length / rowsPerPage);

    const photoColIndex = visibleColumns.indexOf("Photo");

    const renderPrintCell = (cell, colIdx, originalRow) => {
      if (colIdx === photoColIndex) {
        const isValidUrl =
          cell &&
          cell !== "---" &&
          (cell.startsWith("http://") || cell.startsWith("https://"));

        const genderIdIndex = headers.indexOf("Gender ID");
        const genderId = originalRow[genderIdIndex];
        const avatarSrc = genderId === 1 ? maleBase64 : femaleBase64;

        if (isValidUrl) {
          return `<td style="text-align:center;padding:2px;vertical-align:middle;">
            <img src="${cell}" alt="Photo"
              style="width:52px;height:60px;object-fit:contain;object-position:top center;border-radius:4px;display:block;margin:auto;"
              onerror="this.style.display='none';${avatarSrc ? `this.nextSibling.style.display='block';` : ''}" />
            ${avatarSrc ? `<img src="${avatarSrc}" alt="Avatar"
              style="display:none;width:48px;height:48px;object-fit:cover;margin:auto;" />` : ''}
          </td>`;
        } else {
          return `<td style="text-align:center;padding:2px;vertical-align:middle;">
            ${avatarSrc
              ? `<img src="${avatarSrc}" alt="Avatar"
                  style="width:48px;height:48px;object-fit:cover;display:block;margin:auto;" />`
              : `<div style="width:48px;height:48px;display:block;margin:auto;"></div>`
            }
          </td>`;
        }
      }
      return `<td style="text-align:left;padding:4px;">${cell !== null && cell !== undefined ? cell : ''}</td>`;
    };

    const printSection = document.createElement('div');
    printSection.id = 'printSection';

    let printContent = `
      <style>
        body { margin: 0; padding: 0; font-family: 'Calibri', sans-serif; }
        table { width: 100%; border-collapse: collapse; table-layout: fixed;background-color: transparent; font-size: 10px; margin-top: 6mm; }
        th, td { border: 1px solid black; padding: 4px; text-align: center; word-wrap: break-word; font-size: 10px; word-break: break-all; }
        th { font-size: 11px; font-weight: 400; background-color: #ffffff; color: #6A6A6A; }
        .Heading-tc { background-color: #f2f2f2; }
        .header-container { display: flex; justify-content: space-between; align-items: end; margin-bottom: 14px; border-bottom: 1.6px solid #424242; }
        .center-header { text-align: center; font-size: 18px; font-weight: bold; flex-grow: 1; color: #6A6A6A; }
        .logo { width: 140px; height: auto; margin-top: 10px; }
        .right-info { font-size: 10px; color: #6A6A6A; }
        .course-title { font-size: 13px; color: #6A6A6A; }
        .username { text-transform: uppercase; }
        .title-container p { margin-top: 1mm; }
        .title-label { color: #6A6A6A; font-size: 14px; }
        .transparent-table { background-color: rgba(255, 255, 255, 0.5); }
        .watermark {
          position: fixed;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: -1;
          pointer-events: none;
          opacity: 0.15;
        }
        .watermark img { width: auto; height: 200px; }
        .page-block { page-break-after: always; page-break-inside: avoid; }
        .page-block:last-child { page-break-after: auto; }
        @media print {
          body * { visibility: hidden; }
          #printSection, #printSection * { visibility: visible; }
          #printSection { position: absolute; left: 0; top: 0; width: 100%; padding: 10mm; }
          .page-block { page-break-after: always; page-break-inside: avoid; }
          .page-block:last-child { page-break-after: auto; }
        }
        @page { size: auto; margin: 5mm; }
      </style>
    `;

    printContent += `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`;

    const buildHeader = (pageNum) => `
      <div class="header-container">
        <img class="logo" src="${reportImg}" alt="Logo" />
        <h1 class="center-header">${ReportPageHeader}</h1>
        <div class="right-info">
          <p>Print Date&nbsp;&nbsp;: ${formattedDateTime}</p>
          <p>Printed By&nbsp;: <span class="username">${userName}</span></p>
          <p>Page ${pageNum} of ${printTotalPages}</p>
        </div>
      </div>
    `;

    const tableHeader = `
      <thead>
        <tr>${visibleColumns
          .map((heading) => `<th class="Heading-tc">${heading === "Photo" ? "" : heading}</th>`)
          .join("")}</tr>
      </thead>
    `;

    for (let page = 1; page <= printTotalPages; page++) {
      const startIndex = (page - 1) * rowsPerPage;
      const endIndex = Math.min(startIndex + rowsPerPage, sortedData.length);
      const pageRows = sortedData.slice(startIndex, endIndex);
      const pageExportRows = exportData.slice(startIndex, endIndex);

      const isFirstPage = page === 1;

      printContent += `
        <div class="page-block">
          ${buildHeader(page)}
          ${isFirstPage ? `
            <div class="title-container" style="display:flex; justify-content:space-between; align-items:flex-start;">
              <div>
                <p><span class="title-label">Course:</span><span class="course-title"> ${course}</span></p>
              </div>
              <div style="text-align:left;">
                ${test ? `<p><span class="title-label">Test:</span><span class="course-title"> ${test}</span></p>` : ''}
                ${date ? `<p><span class="title-label">Date:</span><span class="course-title"> ${date}</span></p>` : ''}
              </div>
            </div>` : ''}
          <table class="transparent-table">
            ${tableHeader}
            <tbody>
              ${pageRows.map((originalRow, idx) => {
                const exportRow = pageExportRows[idx];
                return `<tr>${exportRow.map((cell, colIdx) => renderPrintCell(cell, colIdx, originalRow)).join('')}</tr>`;
              }).join('')}
            </tbody>
          </table>
        </div>
      `;
    }

    printSection.innerHTML = printContent;
    printSection.style.display = 'none';
    document.body.appendChild(printSection);

    const printStyles = document.createElement('style');
    printStyles.innerHTML = `
      @media print {
        body * { visibility: hidden; }
        #printSection, #printSection * { visibility: visible; }
        #printSection { 
          display: block !important; 
          position: absolute; 
          left: 0; 
          top: 0; 
          width: 100%; 
          padding: 10mm; 
        }
      }
      @media screen {
        #printSection { display: none; } 
      }
      @page { size: auto; margin: 5mm; }
    `;
    document.head.appendChild(printStyles);

    const scrollX = window.scrollX;
    const scrollY = window.scrollY;

    // ✅ Wait for ALL images before printing
    const allImgs = Array.from(printSection.querySelectorAll('img'));

    const waitForImage = (img) =>
      new Promise((resolve) => {
        if (img.complete) {
          resolve();
        } else {
          img.onload = resolve;
          img.onerror = resolve;
        }
      });

  Promise.all(allImgs.map(waitForImage)).then(() => {
    window.print();

    // ✅ Cleanup
    document.body.removeChild(printSection);
    document.head.removeChild(printStyles);

    // ✅ Restore scroll position after print
    window.scrollTo(scrollX, scrollY);
    
    // ✅ Reset loading state
    setIsPrinting(false);
  }).catch((error) => {
    // ✅ Handle any errors
    console.error("Print error:", error);
    document.body.removeChild(printSection);
    document.head.removeChild(printStyles);
    setIsPrinting(false);
  });
};


  const handlePageSizeChange = (size) => {
      setPageSize(size);
      setCurrentPage(1); // Reset to the first page
    };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const totalPages = Math.ceil(sortedData.length / pageSize);
  const paginatedData = React.useMemo(() => {
    const startIndex = (currentPage - 1) * pageSize;
    return sortedData.slice(startIndex, startIndex + pageSize);
  }, [sortedData, currentPage, pageSize]);

  const renderPagination = () => {
    const pages = [];
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(
          <button
            key={i}
            onClick={() => handlePageChange(i)}
            style={{ borderRadius: "5px" }}
            className={i === currentPage ? "active" : ""}
          >
            {i}
          </button>
        );
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 3; i++) {
          pages.push(
            <button
              key={i}
              style={{ borderRadius: "5px" }}
              onClick={() => handlePageChange(i)}
              className={i === currentPage ? "active" : ""}
            >
              {i}
            </button>
          );
        }
        pages.push(
          <span style={{ borderRadius: "5px" }} key="dots1">
            ...
          </span>
        );
        pages.push(
          <button
            key={totalPages}
            onClick={() => handlePageChange(totalPages)}
            style={{ borderRadius: "5px" }}
          >
            {totalPages}
          </button>
        );
      } else if (currentPage > 3 && currentPage < totalPages - 2) {
        pages.push(
          <button
            key={1}
            onClick={() => handlePageChange(1)}
            style={{ borderRadius: "5px" }}
          >
            1
          </button>
        );
        pages.push(
          <span style={{ borderRadius: "5px" }} key="dots1">
            ...
          </span>
        );
        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          pages.push(
            <button
              key={i}
              onClick={() => handlePageChange(i)}
              style={{ borderRadius: "5px" }}
              className={i === currentPage ? "active" : ""}
            >
              {i}
            </button>
          );
        }
        pages.push(
          <span style={{ borderRadius: "5px" }} key="dots2">
            ...
          </span>
        );
        pages.push(
          <button
            key={totalPages}
            onClick={() => handlePageChange(totalPages)}
            style={{ borderRadius: "5px" }}
          >
            {totalPages}
          </button>
        );
      } else {
        pages.push(
          <button
            key={1}
            onClick={() => handlePageChange(1)}
            style={{ borderRadius: "5px" }}
          >
            1
          </button>
        );
        pages.push(
          <span style={{ borderRadius: "5px" }} key="dots1">
            ...
          </span>
        );
        for (let i = totalPages - 2; i <= totalPages; i++) {
          pages.push(
            <button
              key={i}
              onClick={() => handlePageChange(i)}
              style={{ borderRadius: "5px" }}
              className={i === currentPage ? "active" : ""}
            >
              {i}
            </button>
          );
        }
      }
    }
    return pages;
  };

  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    setCurrentPage(1); // Reset to the first page on search


    if (query) {
      const results = [];
      data.forEach((row, rowIndex) => {
        row.forEach((cell, cellIndex) => {
          // Check if the cell is not null or undefined
          if (
            cell !== null &&
            cell !== undefined &&
            cell.toString().toLowerCase().includes(query.toLowerCase()) &&
            cell !== null &&
            cell !== undefined &&
            cell.toString().toLowerCase().includes(query.toLowerCase()) &&
            visibleColumns.includes(headers[cellIndex])
          ) {
            results.push({ rowIndex, cellIndex });
          }
        });
      });
      setSearchResults(results);
      setCurrentSearchIndex(0);
    } else {
      setSearchResults([]);
    }
    setIsSearchModalVisible(true); // Open the search modal
  };

  const highlightText = (text, highlight, isCurrent) => {
    if (!highlight) return text;
    const textStr = text != null ? text.toString() : "";
    const regex = new RegExp(`(${highlight})`, "gi");
    return textStr.split(regex).map((part, index) =>
      part.toLowerCase() === highlight.toLowerCase() ? (
        <span
          key={index}
          style={{ backgroundColor: isCurrent ? "yellow" : "#FFD700" }} // Yellow for current, Dark Yellow for others
        >
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  const moveToNextResult = () => {
    if (searchResults.length === 0) return;

    setCurrentSearchIndex((prevIndex) => {
      const nextIndex =
        prevIndex + 1 < searchResults.length ? prevIndex + 1 : prevIndex;
      const nextResult = searchResults[nextIndex];

      const nextPage = Math.floor(nextResult.rowIndex / pageSize) + 1;

      if (nextPage !== currentPage) {
        setCurrentPage(nextPage);
      }

      return nextIndex;
    });
  };

  const moveToPreviousResult = () => {
    if (searchResults.length === 0) return;

    setCurrentSearchIndex((prevIndex) => {
      const prevIndexAdjusted = prevIndex - 1 >= 0 ? prevIndex - 1 : prevIndex;
      const prevResult = searchResults[prevIndexAdjusted];

      const prevPage = Math.floor(prevResult.rowIndex / pageSize) + 1;

      if (prevPage !== currentPage) {
        setCurrentPage(prevPage);
      }

      return prevIndexAdjusted;
    });
  };


  useEffect(() => {
    if (isPrinting) {
      document.body.style.cursor = "wait";
      document.body.style.pointerEvents = "none";
      // ← ADD THIS: force wait cursor on every element
      const style = document.createElement("style");
      style.id = "printing-cursor-style";
      style.innerHTML = `* { cursor: wait !important; pointer-events: none !important; }`;
      document.head.appendChild(style);
    } else {
      document.body.style.cursor = "";
      document.body.style.pointerEvents = "";
      // ← ADD THIS: remove the injected style
      const style = document.getElementById("printing-cursor-style");
      if (style) document.head.removeChild(style);
    }
    return () => {
      document.body.style.cursor = "";
      document.body.style.pointerEvents = "";
      // ← ADD THIS: cleanup on unmount too
      const style = document.getElementById("printing-cursor-style");
      if (style) document.head.removeChild(style);
    };
  }, [isPrinting]);

  
  return (
    <div>
      <div>
        <div
          className="search-and-pagination-wrapper"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
          }}
        >
          <div
            className="search-wrapper"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "end",
            }}
          >
            <div className="pagination-info">
              Displaying{" "}
              {Math.min((currentPage - 1) * pageSize + 1, sortedData.length)} -{" "}
              {Math.min(currentPage * pageSize, sortedData.length)} of{" "}
              {sortedData.length} records |
              {["10", "25", "50", "100", "500"].map((size) => (
                <span
                  key={size}
                  onClick={() => handlePageSizeChange(Number(size))}
                  style={{
                    cursor: "pointer",
                    margin: "0 5px",
                    textDecoration:
                      size === pageSize.toString() ? "none" : "underline",
                    color: size === pageSize.toString() ? "black" : "#337AB7",
                  }}
                >
                  {size}
                </span>
              ))}
            </div>
          </div>
        </div>
        <div
          className="row-tc"
          style={{
            backgroundColor: "#D6D6D6",
            marginTop: "5px",
            borderTop: "1px solid grey",
            borderBottom: "1px solid grey",
          }}
        >
          <div
            className="col-cs2-TABLE"
            style={{
              backgroundColor: "#FFBD20",
              display: "flex",
              alignItems: "center",
              cursor: data.length > 0 ? "pointer" : "not-allowed",
              paddingLeft: "8px",
            }}
          // onClick={handleFilterClick}
          >
            <img
              src={Filter}
              style={{ height: "25px", width: "25px" }}
              alt="filter"
            />
            <span style={{ marginLeft: "10px", color: "#2F2E40" }}>
              Advance Filter
            </span>
          </div>
          <div
            className="col-cs"
            style={{
              display: "flex",
              alignItems: "center",
              cursor: data.length > 0 ? "pointer" : "not-allowed",
               opacity: isPrinting ? 0.6 : 1, 
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                cursor: isPrinting ? "wait" : (data.length > 0 ? "pointer" : "not-allowed"),
              }}
              onClick={handleExportClick}
            >
              <img
                src={FileExport}
                style={{ height: "25px", width: "25px" }}
                alt="export"
              />
              <span style={{ marginLeft: "10px", color: "#2F2E40" }}>
                Export
              </span>
            </div>
            {isModalVisible && (
              <div
                ref={modalRef}
                style={{ position: "relative", display: "inline-block" }}
              >
                <div className="arrow-up-tc-2"></div>
                <div className="modal-tc-2">
                  <div className="modal-content-tc-2">
                    <button
                      onClick={() => [
                        handleExport("excel"),
                        setIsModalVisible(false),
                      ]}
                    >
                      <FaFileExcel className="Img-EXCEL" />
                      <span style={{ fontSize: "14px" }}>Excel</span>
                    </button>
                    <button
                      onClick={() => [
                        handleExport("csv"),
                        setIsModalVisible(false),
                      ]}
                    >
                      <FaFileCsv className="Img-CSV" />
                      <span style={{ fontSize: "14px" }}>CSV</span>
                    </button>
                  </div>
                </div>
              </div>
            )}
            <div
              className="col-cs"
              style={{
                display: "flex",
                alignItems: "center",
                cursor: data.length > 0 ? "pointer" : "not-allowed",
              }}
            >
              <div
                onClick={() =>
                  data.length > 0 && [
                    handleSaveAndPrint(),
                    setIsModalVisible(false),
                  ]
                }
                style={{ display: "flex", alignItems: "center" }}
              >
                <img src={print} alt="print" />
                <span style={{ marginLeft: "10px", color: "#2F2E40" }}>
                  Print
                </span>
              </div>
            </div>
          </div>
          <div
            className="col-tc"
            onClick={() => setIsSearchModalVisible(!isSearchModalVisible)}
          >
            <img
              src={searchicon}
              style={{ height: "25px", width: "25px" }}
              alt="search"
            />
            <span style={{ marginLeft: "10px", color: "#2F2E40" }}>Search</span>
          </div>
          {isSearchModalVisible && (
            <div>
              <div className="inside-search-table-items">
                <div className="inside-table-search-items">
                  <div className="search-input-container">
                    <input
                      type="text"
                      placeholder="Search..."
                      name="search"
                      value={searchQuery}
                      onChange={handleSearch}
                    />
                  </div>
                  <div className="search-results-container">
                    <span style={{ width: "65px" }}>
                      {searchResults.length > 0
                        ? `${currentSearchIndex + 1} of ${searchResults.length}`
                        : ""}
                    </span>
                  </div>
                  <div className="button-container">
                    <img
                      src={upimg}
                      alt="up"
                      onClick={moveToPreviousResult}
                      style={{
                        filter:
                          currentSearchIndex > 0
                            ? "invert(48%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(75%) contrast(90%)"
                            : "brightness(0.5) invert(0.5)",
                        cursor:
                          currentSearchIndex > 0 ? "pointer" : "not-allowed",
                      }}
                      disabled={
                        searchResults.length === 0 || currentSearchIndex === 0
                      }
                    />
                    <img
                      src={downimg}
                      alt="down"
                      onClick={moveToNextResult}
                      style={{
                        filter:
                          currentSearchIndex < searchResults.length - 1
                            ? "invert(48%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(75%) contrast(90%)"
                            : "brightness(0.5) invert(0.5)",
                        cursor:
                          currentSearchIndex < searchResults.length - 1
                            ? "pointer"
                            : "not-allowed",
                      }}
                      disabled={
                        searchResults.length === 0 ||
                        currentSearchIndex === searchResults.length - 1
                      }
                    />
                    <span
                      onClick={() => {
                        setSearchQuery("");
                        setSearchResults([]); // Clear search results
                        setCurrentSearchIndex(0); // Reset search index
                        setIsSearchModalVisible(false);
                      }}
                    >
                      <img src={cross} alt="cross" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div
            ref={columnDivRef}
            className="col-tc"
            style={{
              textAlign: "end",
              marginRight: "8px",
              display: "flex",
              alignItems: "center",
              position: "relative",
              cursor: data.length > 0 ? "pointer" : "not-allowed",
            }}
            onClick={handleColumnDivClick}
          >
            <img
              src={columnaddition}
              style={{ height: "25px", width: "25px" }}
              alt="column addition"
            />
            <span style={{ marginLeft: "10px", color: "#2F2E40" }}>
              Column Selection
            </span>
            {isColumnDivVisible && (
              <>
                <div className="arrow-up-tc"></div>
                <div className="popupColumn-tc">
                    {headers
                    .filter((column) => column !== "Student ID" && column !== "Gender ID")
                    .map((column, index) => {
                      return (
                        <div
                          key={index}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleColumnSelection(column);
                          }}
                        >
                          <input
                            type="checkbox"
                            id={`column-${index}`}
                            name="columnSelection"
                            value={column}
                            className="square-checkbox-tc"
                            checked={visibleColumns.includes(column)}
                            // disabled={isRequired}
                            readOnly
                          />
                          <label
                            htmlFor={`column-${index}`}
                            style={{
                              marginLeft: "10px",
                              maxWidth: "110px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              display: "inline-block",
                            }}
                          >
                            {column}
                          </label>
                        </div>
                      );
                    })}
                </div>
              </>
            )}
          </div>
        </div>
        <div
          className="table-wrapper"

          style={{
            maxHeight: isExpanded ? "58.5vh" : "36vh",
            overflowY: "auto",
            overflowX: "auto",
            minWidth: "100%",
            maxWidth: "82.2vw",
            marginRight: "auto",
          }}
        >
          {data.length === 0 ? (
            <div style={{ textAlign: "center", marginTop: "20px" }}></div>
          ) : (
            <table className="table-tc" style={{ width: "100%" }}>
              <thead>
                <tr>
                  {visibleColumns.map((heading, index) => (
                    <th
                      onClick={() => handleSort(heading)}
                      className="Heading-tc"
                      key={index}
                      style={{
                        textAlign: "center",
                        cursor: "pointer",
                        position: "sticky",
                        top: "0",
                        zIndex: 2,
                        backgroundColor: "white",
                        width: heading === "Photo" ? "80px" : "auto",
                        padding: heading === "Photo" ? "8px 78px 8px 40px" : "8px 8px",
                        fontWeight: "400",        
                        fontSize: "14px",         
                        color: "#6A6A6A",       
                      }}
                    >
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: heading === "Photo" ? "center" : "left",
                        }}
                      >
                        {heading === "Photo" ? null : (
                          <>
                            {heading}
                            <img
                              onClick={() => handleSort(heading)}
                              src={updown}
                              style={{ height: "20px", width: "20px", marginLeft: "5px" }}
                              alt="sort"
                            />
                          </>
                        )}
                      </span>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {paginatedData.map((row, rowIndex) => (
                  <tr
                    key={rowIndex}
                    className={rowIndex % 2 === 1 ? "even-row-tc" : ""}
                  >
                    {visibleColumns.map((column) => {
                      const cellIndex = headers.indexOf(column);
                      const cellValue = row[cellIndex];
                      if (column === "Photo") {
                        const isValidUrl =
                          cellValue &&
                          cellValue !== "---" &&
                          (cellValue.startsWith("http://") || cellValue.startsWith("https://"));
                        return (
                          <td
                            key={column}
                            style={{ textAlign: "center", color: "#6A6A6A", padding: "6px 4px" }}
                          >
                          <div
                          className="student-avatar-wrapper"
                          style={{ cursor: "pointer" }}  
                          onClick={() => {
                            const studentId = row[headers.indexOf("Student ID")];
                            window.open(`/student_dashboard?studentId=${studentId}`, "_blank");
                          }}
                          title="View student dashboard"
                        >
                          {isValidUrl ? (
                            <>
                              <img
                                src={cellValue}
                                alt="Student"
                                className="student-avatar"
                                onError={(e) => {
                                  e.currentTarget.style.display = "none";
                                  e.currentTarget.nextSibling.style.display = "block";
                                }}
                              />
                              <img
                                src={getGenderAvatar(row)}
                                alt="Avatar"
                                className="student-avatar-placeholder student-avatar-fallback"
                                style={{ display: "none" }}
                              />
                            </>
                          ) : (
                            <img
                              src={getGenderAvatar(row)}
                              alt="Avatar"
                              className="student-avatar-placeholder"
                            />
                          )}
                        </div>
                          </td>
                        );

                      }
                      return (
                        <td
                          key={column}
                          style={{ textAlign: "left", color: "#6A6A6A" }}
                        >
                          {highlightText(
                            cellValue,
                            searchQuery,
                            searchResults.length > 0 &&
                            searchResults[currentSearchIndex]?.rowIndex === rowIndex &&
                            searchResults[currentSearchIndex]?.cellIndex === cellIndex
                          )}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
        {data.length > 0 && totalPages > 1 && (
          <div className="pagination-tc">
            <button
              onClick={() => handlePageChange(1)}
              disabled={currentPage === 1}
              className="extreme-left-tc-pagination"
            >
              <img src={leftArrow} alt="left arrow" />
            </button>
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className="lefttc-pagination"
            >
              {"<"}
            </button>
            {renderPagination()}
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="righttc-pagination"
            >
              {">"}
            </button>
            <button
              onClick={() => handlePageChange(totalPages)}
              disabled={currentPage === totalPages}
              className="extreme-right-tc-pagination"
            >
              <img src={rightArrow} alt="right arrow" />
            </button>
          </div>
        )}
        {isFilterVisible && (
          <div className="filter-sidebar-AdvanceFilter">
            <div className="filter-content-AdvanceFilter">
              <button
                className="repman-cross-btn"
                style={{
                  position: "absolute",
                  left: "-29px",
                  height: "40px",
                  width: "30px",
                  color: "white",
                  border: "none",
                  fontSize: "20px",
                  fontWeight: "700",
                  borderRadius: "5px 0px 0px 5px",
                }}
                onClick={() => {
                  setIsFilterVisible(false);
                }}
              >
                <p>X</p>
              </button>
              <h3 className="AdvanceF-heading-tc">Advance Filter</h3>
              {children}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TemRegDetailsTable;

